import { toast } from '@/lib/notify';

// The SHARED workflow link — one common URL per workflow (/wf/{slug}). Anyone who
// opens it gets their own session (resolve-or-create on the server). Copying it
// does NOT create a session; sessions are created when a visitor opens the link.
const linkForSlug = (slug: string) => `${window.location.origin}/wf/${slug}`;

export function useCopyWorkflowLink() {
  function copy(slug: string) {
    if (!slug) {
      toast.error('No shareable link available for this workflow');
      return;
    }
    const link = linkForSlug(slug);
    if (!navigator.clipboard) {
      toast.message('Copy this link', { description: link, duration: 10_000 });
      return;
    }
    navigator.clipboard
      .writeText(link)
      .then(() => toast.success('Link copied'))
      // Clipboard blocked — surface the link so it can be copied by hand.
      .catch(() => toast.message('Copy this link', { description: link, duration: 10_000 }));
  }

  // isPending kept for call-site compatibility; copying is now synchronous.
  return { copy, isPending: false };
}
